export const baseRouteGetObject = (name: string, slug: string, queries: object) => {
  const QueryBySlugOptions = queries ? { query: queries } : {}
  const paramsObject = slug ? { params: { slug } } : {}
  return {
    name: name || 'index',
    ...paramsObject,
    ...QueryBySlugOptions
  }
}
